import Quimbee from "quimbee"
import { post } from "@rails/request.js"
import Modal from 'components/modal'
import { waitForQuimbeeDataKey } from "controllers/quimbee_data_controller"

class HubSpotContact {
  async initialize() {
    await this.setConversationSettings()

    // Set up any link to open the HubSpot contact form
    const hbLinks = document.querySelectorAll("[data-contact-widget]")

    if (hbLinks.length > 0) {
      hbLinks.forEach(hbLink => {
        hbLink.addEventListener("click", (e) => {
          e.preventDefault()
          window.HubSpotConversations.widget.open()
        })
      })
    }

    const widgetOpen = document.querySelector("[data-contact-widget-open]") !== null
    if (widgetOpen) {
      // If we want chat widget auto popup and after 5 seconds and it doesn't happen,
      // pop up block formed modal
      const popupModal = setTimeout(() => { this.displayBlockedForModal() }, 5000)

      window.addEventListener("hubspot.contact.open", () => {clearTimeout(popupModal)})
    }
  }

  async setConversationSettings() {
    if (Quimbee.isSignedInUser) {
      await waitForQuimbeeDataKey("hubSpotChatVisitorIdentification")

      Quimbee.data.hubSpotChatVisitorIdentification ||= {}

      // Fetch new hubspot token via ajax if it's expired or unexisting
      if (!Quimbee.data.hubSpotChatVisitorIdentification.expiration || Quimbee.data.hubSpotChatVisitorIdentificationExpired) {
        try {
          const response = await post("/hubspot_token")
          Quimbee.data.hubSpotChatVisitorIdentification = await response.json
        } catch(e) {
          console.warn(`Unable to create Hubspot token! ${e.message}`)
        }
      }

      window.hsConversationsSettings.identificationEmail = Quimbee.data.hubSpotChatVisitorIdentification.email
      window.hsConversationsSettings.identificationToken = Quimbee.data.hubSpotChatVisitorIdentification.token
    }
  }

  load() {
    if (window.HubSpotConversations) {
      this.onHsConversationsReady()
    } else {
      window.hsConversationsOnReady = [ this.onHsConversationsReady ]
    }
  }

  displayBlockedForModal() {
    Modal.show("blocked_form_modal")
  }

  onHsConversationsReady() {
    const widgetOpen = document.querySelector("[data-contact-widget-open]") !== null

    window.HubSpotConversations.widget.load({ widgetOpen: widgetOpen })

    if (widgetOpen) {
      window.dispatchEvent(new CustomEvent("hubspot.contact.open"))
    }
  }
}

export default HubSpotContact
